import { useI18n } from 'vue-i18n'

import useConfirmation from '@lib/composables/useConfirmation'
import useCanvas from '@canvas-builder/composables/useCanvas'

let isExiting = false

export default function useCanvasExit() {
  const { t } = useI18n()
  const confirmation = useConfirmation()
  const { isRedirectEvent, onExit, isSameAsSaved, saveCanvasContent } = useCanvas()
  const onEscOrCancel = () => {
    isExiting = false
  }
  const exit = () => {
    if (!isRedirectEvent.value) {
      isExiting = false
      onExit.value()
      return
    }

    confirmation.warning({
      hasExit: false,
      title: t('canvasUI.canvasBuilder.confirmationOnRedirectEventExit.title'),
      content: t('canvasUI.canvasBuilder.confirmationOnRedirectEventExit.content'),
      confirmText: t('canvasUI.canvasBuilder.confirmationOnRedirectEventExit.confirm'),
      cancelText: t('canvasUI.canvasBuilder.confirmationOnRedirectEventExit.cancel'),
      onMaskClick: onEscOrCancel,
      onEsc: onEscOrCancel,
      onCancel: onEscOrCancel,
      onConfirm: async () => {
        isExiting = false
        onExit.value()
      },
    })
  }

  const onExitClick = () => {
    if (isExiting) return
    isExiting = true
    if (isSameAsSaved.value) {
      exit()
      return
    }

    confirmation.warning({
      title: t('canvasUI.canvasBuilder.confirmationOnUnsavedChanges.title'),
      content: t('canvasUI.canvasBuilder.confirmationOnUnsavedChanges.content'),
      confirmText: t('canvasUI.canvasBuilder.confirmationOnUnsavedChanges.confirm'),
      cancelText: t('canvasUI.canvasBuilder.confirmationOnUnsavedChanges.cancel'),
      exitText: t('canvasUI.canvasBuilder.confirmationOnUnsavedChanges.exit'),
      onMaskClick: onEscOrCancel,
      onEsc: onEscOrCancel,
      onCancel: onEscOrCancel,
      onConfirm: async () => {
        try {
          await saveCanvasContent()
        } catch (error) {
          console.error(error)
          return
        }
        exit()
      },
      onExit: () => {
        exit()
      },
    })
  }

  return {
    onExitClick,
  }
}
